
<template>
  <v-container class="pa-0">
    <v-row justify-start>
      <v-col cols="12" sm="auto" class="pt-0 pb-0">
        <profile-avatar :profile="userDisplayed" />
      </v-col>
      <v-col cols="12" sm="auto" class="pt-0 flex-grow-1">
        <v-container ma-0 pa-0 fill-height fluid>
          <v-row align="end">
            <v-col class="pb-0 pt-0">
              <span class="title" style="color:white;">
                {{userDisplayed.name}}
                <verified-sign v-if="userDisplayed.verified" />
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row v-if="userDisplayed.email">
      <v-col>{{$t('common.email-address')}}</v-col>
      <v-col>{{userDisplayed.email}}</v-col>
    </v-row>
    <v-row v-if="loading">
      <v-col class="pb-3 ma-0">
        <v-progress-linear :indeterminate="true" :height="2"></v-progress-linear>
      </v-col>
    </v-row>
    <v-row v-if="userDisplayed.bio">
      <v-col class="pt-0">
        <span style="white-space: pre-wrap;">{{userDisplayed.bio}}</span>
      </v-col>
    </v-row>
    <v-row v-if="userDisplayed.friendship !== null">
      <v-col v-if="userDisplayed.friendship">
        <span>
          <v-icon left>mdi-check</v-icon>{{$t('playerProfileContent.you-are-friends')}}
        </span>
      </v-col>
      <v-col v-if="userDisplayed.frienshipRequestExists">
        <span>
          <v-icon left>mdi-check</v-icon>{{$t('playerProfileContent.friendrequest-sent')}}
        </span>
      </v-col>
      <v-col v-if="userDisplayed.frienshipRequestToMeExists">
        <span>
          <v-icon left>mdi-email</v-icon>{{$t('playerProfileContent.friendrequest-received')}}
        </span>
      </v-col>
    </v-row>
    <div v-if="userDisplayed.friendship !== null && userDisplayed.friendship == false">
      <v-btn
        v-if="userDisplayed.frienshipRequestToMeExists === false"
        text
        class="secondary"
        @click="requestFriendship(userDisplayed)"
        :disabled="$store.state.isLoading || userDisplayed.frienshipRequestExists"
        :loading="loadingFriendRequest"
      >
        <v-icon left>mdi-account-plus</v-icon>Anfrage senden
      </v-btn>
      <v-btn
        v-if="userDisplayed.frienshipRequestToMeExists"
        text
        class="secondary"
        @click="decideFriendship(userDisplayed, true)"
        :disabled="$store.state.isLoading"
        :loading="loadingFriendRequest"
      >
        <v-icon left>mdi-account-plus</v-icon>Annehmen
      </v-btn>
    </div>
    <div v-if="userDisplayed.externalAccounts && userDisplayed.externalAccounts.length > 0">
      <v-row
        v-for="externalAccount in userDisplayed.externalAccounts"
        :key="externalAccount.driver"
      >
        <v-col class="pl-0 pb-0">
          <socialite-open-button :externalAccount="externalAccount"/>
        </v-col>
      </v-row>
      <v-row
          v-if="userDisplayed.insta_handle"
      >
        <v-col class="pl-0 pb-0">
          <v-btn

              :href="`https://instagram.com/${userDisplayed.insta_handle}`"
          ><v-icon class="mr-2">mdi-instagram</v-icon> Instagram</v-btn>
        </v-col>
      </v-row>
      <v-row
          v-if="userDisplayed.twitter_handle"
      >
        <v-col class="pl-0 pb-0">
          <v-btn
              :href="`https://twitter.com/${userDisplayed.twitter_handle}`"
          ><v-icon class="mr-2">mdi-twitter</v-icon> Twitter</v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-if="userDisplayed.platforms && userDisplayed.platforms.length > 0">
      <v-row>
        <v-col class="pb-0">
          <span class="subtitle-1">Online-IDs</span>
        </v-col>
      </v-row>
      <v-row
        v-for="platform in userDisplayed.platforms"
        :key="platform.platform_code + '_' + platform.game_code"
        class="align-center"
      >
        <v-col cols="12">
          <user-online-id :platformCode="platform.platform_code" :onlineId="platform.platform_nickname" :gameCode="platform.game_code" :highlight="platform === highlightedUserPlatform"/>
        </v-col>
      </v-row>
    </div>
    <div v-if="showFriends && userDisplayed.friends && userDisplayed.friends.length > 0">
      <v-row>
        <v-col class="pb-0">
          <span class="subtitle-1">{{$t('friends.title')}}</span>
        </v-col>
      </v-row>
      <v-row v-for="friend in userDisplayed.friends" v-bind:key="friend.uid" class="align-center">
        <v-col>
          <user-widget :user="friend" :showDefaultActions="[]" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import platformMixins from "@/mixins/platformMixins.js";
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store.js";
import VerifiedSign from "@/widgets/VerifiedSign";
import ProfileAvatar from "@/widgets/ProfileAvatar";
import Vue from "vue";
import UserOnlineId from "@/widgets/UserOnlineId";
import SocialiteOpenButton from './SocialiteOpenButton.vue';

export default {
  name: "PlayerProfileContent",
  mixins: [platformMixins],
  components: { VerifiedSign, ProfileAvatar, UserOnlineId, SocialiteOpenButton },
  props: {
    user: {
      type: Object,
      required: true
    },
    game: {
      type: Object,
      required: false
    },
  },
  data: function() {
    return {
      loading: false,
      showFriends: false,
      userDisplayed: null,
      loadingFriendRequest: false
    };
  },
  computed: {
    highlightedUserPlatform() {
      if (! this.userDisplayed || ! this.userDisplayed.platforms || ! this.game) {
        return null
      }
      var ret = null
      this.userDisplayed.platforms.forEach(userPlatform => {
        if (userPlatform.platform_code == this.game.platform) {
          ret = userPlatform
        }
      });
      this.userDisplayed.platforms.forEach(userPlatform => {
        if (userPlatform.platform_code == this.game.platform && userPlatform.game_code == this.game.game) {
          ret = userPlatform
        }
      });
      return ret
    },
  },
  watch: {
    value: function() {
      // console.log("value changed to", val);
    }
  },
  created() {
    console.log("content created");
    this.userDisplayed = this.user
  },
  mounted() {
    this.refresh();
    Vue.nextTick(() => {
      this.showFriends = true;
    });
  },
  methods: {
    refresh() {
      console.log("Loading player profile " + this.user.uid);
      this.loading = true;
      this.$api
        .getUsersProfile(this.user.uid)
        .then(response => {
          this.loading = false;
          this.userDisplayed = response.data;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
      this.$ga.send({
        hitType: "event",
        eventCategory: "User",
        eventAction: "details",
        eventLabel: "View user details"
      });
    },
    requestFriendship(user) {
      console.log("Requesting friendship @ " + user.uid);
      this.error = undefined;
      this.loadingFriendRequest = true;
      this.$api
        .requestFriendship(user.uid)
        .then(() => {
          this.loadingFriendRequest = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: `Freundschaftsanfrage an '${user.name}' gestellt`,
            type: "success"
          });
          this.refresh();
        })
        .catch(error => {
          // also catches the store authorized error
          this.loadingFriendRequest = false;
          this.$common.onError(error)
        });
    },
    decideFriendship(user, accept) {
      this.loadingFriendRequest = true;
      this.$api
        .decideFriendship(user.uid, accept)
        .then(() => {
          this.loadingFriendRequest = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: `Freundschaftsanfrage angenommen`,
            type: "success"
          });
          this.refresh();
        })
        .catch(error => {
          this.loadingFriendRequest = false;
          this.$common.onError(error)
        });
    },
  }
};
</script>
